__webpack_require__.p = "https://static.age.awaze.com/search-mfe/18862fe/_next/";